import { render, staticRenderFns } from "./DialogReleaseNotes.vue?vue&type=template&id=63f9ae32&scoped=true"
import script from "./DialogReleaseNotes.vue?vue&type=script&lang=js"
export * from "./DialogReleaseNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f9ae32",
  null
  
)

export default component.exports